export default [
  { id: 1, name: 'Хобби 1' },
  { id: 2, name: 'Хобби 2' },
  { id: 3, name: 'Хобби 3' },
  { id: 4, name: 'Хобби 4' },
  { id: 5, name: 'Хобби 5' },
  { id: 6, name: 'Хобби 6' },
  { id: 7, name: 'Хобби 7' },
  { id: 8, name: 'Хобби 8' },
  { id: 9, name: 'Хобби 9' },
  { id: 10, name: 'Хобби 10' },
];
